"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.patchCondition = void 0;
/**
 * Update an condition.
 */
var patchCondition = function (instance) {
    return function (id, body, config) {
        return instance.patch("/notifications/conditions/".concat(id), body, config);
    };
};
exports.patchCondition = patchCondition;
